<template>
  <div>
    <div class="sb_frame">
      <div class="sb_frame_overlay"></div>
      <DropFile
        @file="updateImage"
        class="sb_frame_dropfile"
        v-if="!loading && !poem"
      />
      <img :src="image" class="sb_frame_image" alt="" v-if="image" />
      <img :src="image" class="sb_frame_image-faux" alt="" v-if="image" />
      <div class="sb_frame_bg"></div>
    </div>

    <div class="sb_content">
      <div v-if="loading" class="sb_content_loading">
        <div class="sb_content_loading_loader">
          <img src="loader.gif" />
        </div>
        <div class="sb_content_loading_text">
          Loading the poem. This could take a minute. Here are some random fun
          facts:
        </div>
        <FunFactsRotator class="sb_content_loading_funfacts" />
      </div>
      <div v-if="!loading && !poem"></div>
      <p v-if="error" style="color: red">{{ error }}</p>
      <div v-if="poem" class="sb_content_poem">
        <div v-html="poem"></div>
      </div>
      <div class="sb_content_disclaimer">
        <div class="sb_content_disclaimer_inner">
          <a href="https://stijlbreuk.nl/" target="_blank"
            ><img src="logo.svg"
          /></a>
          <br />
          <p>
            Disclaimer: The poem is generated by AI. Unfortunately it's not
            perfect and it makes mistakes :). Use at your own caution! We are
            not responsible for any feelings that may be hurt.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DropFile from "@/components/DropFile.vue";
import FunFactsRotator from "@/components/FunFactsRotator.vue";

export default {
  data() {
    return {
      error: null,
      loading: false,
      poem: null,
      image: null,
    };
  },
  components: {
    DropFile,
    FunFactsRotator,
  },
  methods: {
    async updateImage(file) {
      this.loading = true;
      this.error = null;
      this.poem = null;

      let formData = new FormData();
      formData.append("image", file);
      this.image = URL.createObjectURL(file);

      try {
        const res = await this.getPoem(formData);
        this.poem = res;
        // this.image = res[1];
      } catch (error) {
        this.error =
          (error.response && error.response.data) || error.message || error;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getImage(formData) {
      const { data } = await axios.post(
        `${process.env.VUE_APP_ENDPOINT}/cartoonization`,
        formData,
        {
          mode: "no-cors",
          headers: {
            accept: "image/jpg",
            "content-type": "multipart/form-data",
          },
          responseType: "arraybuffer",
        }
      );
      return `data:image/jpeg;base64,${Buffer.from(data).toString("base64")}`;
    },
    async getPoem(formData) {
      const response = await axios.post(
        `${process.env.VUE_APP_ENDPOINT}/poem/from-image`,
        formData,
        {
          mode: "no-cors",
          headers: {},
        }
      );
      return response.data.replace(/\n/g, "<br />");
    },
  },
};
</script>

<style lang="scss">
body {
  background: #e3e2e1;
  padding: 0;
  margin: 0;
}
.sb_frame {
  width: 100vw;
  height: 100vw;
  inset: 0;
  position: absolute;
  z-index: 1;

  @media screen and (min-width: 800px) {
    width: 800px;
    height: 800px;
    left: 50%;
    transform: translateX(-50%);
  }

  &_overlay {
    position: absolute;
    z-index: 4;
    background-image: url("/frame.png");
    background-size: contain;
    pointer-events: none;
    width: 100vw;
    height: 100vw;

    @media screen and (min-width: 800px) {
      width: 800px;
      height: 800px;
    }
  }

  &_image,
  &_image-faux,
  &_bg {
    position: absolute;
    pointer-events: none;
    width: 65vw;
    height: 65vw;
    top: 20vw;
    left: 20vw;
    @media screen and (min-width: 800px) {
      width: 500px;
      height: 500px;
      top: 165px;
      left: 176px;
    }
  }
  &_image {
    z-index: 3;
    object-fit: contain;
  }
  &_image-faux {
    z-index: 2;
    opacity: 0.5;
    filter: blur(10px);
  }
  &_bg {
    z-index: 1;
    background: black;
  }

  &_dropfile {
    position: absolute;
    z-index: 2;
    width: 100vw;

    @media screen and (min-width: 800px) {
      width: 500px;
      top: 165px;
      left: 176px;
    }
  }
}

.sb_content {
  position: relative;
  z-index: 2;
  top: 90vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 100vw);
  text-align: center;
  padding: 0 1rem;
  @media screen and (min-width: 800px) {
    width: 590px;
    position: absolute;
    left: 50%;
    transform: translateX(calc(-50% + 30px));
    top: 700px;
    height: calc(100vh - 700px);
  }

  &_loading {
    &_loader {
      display: flex;
      justify-content: center;
      padding: 0 0 10px 0;
      img {
        width: 30px;
        height: 30px;
      }
    }
    &_text {
    }
    &_funfacts {
      margin: 10px 0 0 0;
      background: #fff;
      padding: 20px;
      border-radius: 10px;
      font-size: 4vw;

      @media screen and (min-width: 800px) {
        font-size: 20px;
      }
    }
  }
  &_poem {
    font-family: "Amatic SC", cursive;
    padding: 0 0 30px 0;
    font-size: 7vw;
    @media screen and (min-width: 800px) {
      font-size: 40px;
    }
  }
  &_disclaimer {
    padding: 40px 0 0 0;
    color: black;
    font-size: 14px;
    &_inner {
      padding: 20px 0;
      border-top: solid 1px #ccc;
    }
    p {
      color: rgba(#000, 0.5);
    }
    img {
      height: 30px;
    }
    a {
      text-decoration: none;
      transition: opacity 0.3s ease;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
</style>
